import clsx from 'clsx';

import { formatLastSyncTime } from '@/utils/sync-time-formatter';

import styles from './last-sync-edit-time.module.scss';

const SYNC_TIME_TOLERANCE_MS = 5000; // prevents flickering when sync and edit times are very close

export const LastSyncEditTime = ({ lastSyncTime, lastEditTime, className }: LastSyncEditTimeProps) => {
  if (!lastSyncTime && !lastEditTime) {
    return null;
  }

  const syncTime = lastSyncTime ? new Date(lastSyncTime).getTime() : 0;
  const editTime = lastEditTime ? new Date(lastEditTime).getTime() : 0;
  const isSyncMostRecent = lastSyncTime && syncTime >= editTime - SYNC_TIME_TOLERANCE_MS;

  return (
    <span className={clsx(styles.lastSyncEditTime, className)}>
      {isSyncMostRecent ? 'Last sync ' : 'Last edit '}
      {formatLastSyncTime(Math.max(syncTime, editTime))}
    </span>
  );
};

export interface LastSyncEditTimeProps {
  lastSyncTime?: string;
  lastEditTime?: string;
  className?: string;
}
